import React, { useContext, useMemo } from 'react';
import { useLoadSavedHCPCS } from '@mummssoftware/common-ui';
import { HCPCSContext } from '../Context/contexts/HCPCSContext';
import { VisitContext } from '../Context/contexts/VisitContext';
import {
  SET_HCPCS_CHOICE,
  SET_HCPCS_DURATION,
  SET_ICD_SECTION,
  ADD_SAVED_ICD_CODE,
} from '../Context/constants';

export const getSavedHcpcsAnswers = (
  visit: mumms.PatientVisit | null | undefined,
) => {
  const raw =
    (visit as any)?.physicianServices ?? (visit as any)?.physicianservices;
  if (!raw) {
    return null;
  }
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return Array.isArray(raw) ? raw : null;
};

export const visitHasSavedHCPCS = (
  visit: mumms.PatientVisit | null | undefined,
) => {
  const answers = getSavedHcpcsAnswers(visit);
  return !!(answers && answers.length);
};

export const LoadSavedHCPCS = () => {
  const { dispatchHCPCS } = useContext(HCPCSContext);
  const { savedVisit } = useContext(VisitContext);

  const hcpcsMenu = useMemo(() => {
    const hcpcsMenuConfig: any = window.env?.hcpcs || null;
    const keyRole = savedVisit?.careProviderRoleGroup
      ?.toLowerCase()
      .replace(/\s/g, '');
    return hcpcsMenuConfig && keyRole ? hcpcsMenuConfig[keyRole] : [];
  }, [savedVisit?.careProviderRoleGroup]);

  const hcpcsData = getSavedHcpcsAnswers(savedVisit);

  useLoadSavedHCPCS(
    hcpcsData,
    dispatchHCPCS,
    hcpcsMenu,
    SET_HCPCS_CHOICE,
    SET_HCPCS_DURATION,
    SET_ICD_SECTION,
    ADD_SAVED_ICD_CODE,
  );

  return null;
};
